<div class="content">
  <ion-toggle
    [disabled]="toggleIsDisabled"
    [checked]="toggleIsOn"
    (ionChange)="setToggle()"
    aria-labelledby="usf-deliveries"
  ></ion-toggle>
  <ion-label id="usf-deliveries">US Foods Delivered</ion-label>
</div>
